import React, { useEffect, useRef } from "react";
import { Box, Flex } from "@chakra-ui/react";
import "./index.css";
export const PreviewPlayer = ({ layoutItem, scale }) => {
    const scrollData = layoutItem.widget.data;
    const containerRef = useRef(null);
    const textRef = useRef(null);
    useEffect(() => {
        var _a;
        const textWidth = ((_a = textRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) || 0;
        const interval = setInterval(() => {
            var _a;
            if (containerRef.current !== null) {
                const scrollLeft = containerRef.current.scrollLeft;
                containerRef.current.scrollTo({
                    left: scrollLeft * scale * ((_a = layoutItem.scale) !== null && _a !== void 0 ? _a : 1) < textWidth
                        ? scrollLeft + scrollData.scrollSpeed / 2
                        : 0,
                    behavior: "auto",
                });
            }
        }, 16);
        return () => clearInterval(interval);
    }, [
        scrollData.scrollSpeed,
        scale,
        textRef,
        containerRef.current,
        scrollData.text,
        layoutItem,
    ]);
    return scrollData !== null ? (React.createElement(Flex, { gap: "8px", width: "100%", height: "100%", ref: containerRef, textColor: scrollData.textColor, backgroundColor: scrollData.backgroundColor, fontFamily: scrollData.font, fontSize: scrollData.size, whiteSpace: "nowrap", overflow: "scroll" },
        React.createElement(Box, { flexBasis: "100%", flexShrink: 0, key: "preview", ref: textRef, fontWeight: scrollData.weight }, scrollData.text),
        React.createElement(Box, { flexShrink: 0, flexBasis: "100%", fontWeight: scrollData.weight }, scrollData.text))) : (React.createElement(React.Fragment, null));
};
